import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class SentSlowService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  // public getAllCompanies(querySearch?: any): Promise<any> {
  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .post("/api/business/company?page=0&size=10000", querySearch)
  //       .then((res) => {
  //         resolve(res.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }

  public getAllCompanies(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/companyList`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getBusinessCpn(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/company-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getTypeOfDispatch(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/doc/bcdt-doc-types")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getLicNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-numbers")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-types")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicCpnLicensee() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-cpn-licenses")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicCpnbusinessSearch() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/telcoService/businessSearch")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public SearchincomeFee(querySearch: any, cancelToken): Promise<any> {
    let url = "/api/business/f-mgm";
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public excelTlm(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/late/payment/export/excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public onSearch(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/late/payment/search", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public lateSlowGen(query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/genrate/late/payment`, query, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public calculationDate(id?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/late/payment/calculationDate" + "?id=" + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public dongbo(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/sync/late/payment")
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public dispatchPaymentFee(id?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/late/payment/dispatchPaymentFee" + "?id=" + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  // public genrateList(id?: any): Promise<any> {
  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .get("/api/business/genrate/list")
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((err) => {
  //         console.log(reject(err));
  //       });
  //   });
  // }

  public genrateList(page: any, size: any, type: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/genrates?type=${type}&page=${page}&size=${size}&sort=id:desc`, {})
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  // public genrateDocLatePaymentFinal(foder?: any): Promise<any> {
  //   let foderFinal = foder;
  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .post("/api/business/payment/final", foderFinal, { responseType: "blob" })
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((err) => {
  //         console.log(reject(err));
  //       });
  //   });
  // }

  public downCV(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/v2/payment/final?id=${id}`, {}, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public lateSlowSave(body?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/late-pay-fee/save`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public lateSlowSaveid(body?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/late/payment/paid`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public lateSlowSaveidClose(body?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/late/payment/paid/close`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
